export function scrollDirection() {
  const throttle = (func, time = 100) => {
    let lastTime = 0;
    return () => {
      const now = new Date();
      if (now - lastTime >= time) {
        func();
        time = now;
      }
    };
  };
  const toggleDirBottom = document.querySelectorAll(".toggle-dir-bottom");
  let prevScrollpos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  let currentScTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  const SCROLL_HEADER_SHOWHIDE = () => {
    const currentScrollPos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    if(!document.body.classList.contains('is-disable-scroll-direction')) {
      if(currentScTop < currentScrollPos || currentScrollPos < currentScTop) {
        if (prevScrollpos < currentScrollPos && currentScrollPos > 0) {
          document.body.classList.add('dir-bottom');
        } else {
          document.body.classList.remove('dir-bottom');
        }
      }
    }
    prevScrollpos = currentScrollPos;
  }
  SCROLL_HEADER_SHOWHIDE();
  window.addEventListener("scroll", throttle(SCROLL_HEADER_SHOWHIDE, 200));
  
  setTimeout(() => {
    if(!document.body.classList.contains('is-disable-scroll-direction')) {
      document.body.classList.add('dir-bottom');
    }
  }, 1500)

  if(toggleDirBottom.length){
    toggleDirBottom.forEach((button, index) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        if(document.body.classList.contains('dir-bottom')) {
          document.body.classList.remove('dir-bottom');
        } else {
          document.body.classList.add('dir-bottom');
        }
      });
    });
  }
}